import React, { Component } from 'react'
import { Link } from 'react-router-dom'

export default class Header extends Component {

    /**
     * Render
     * 
     * @returns {Component}
     */
    render() {
        return (
            <div className="app-sidebar-logo px-6" id="kt_app_sidebar_logo">

                {/* LOGO */}
                <Link to="/admin">
                    {/* <img alt="Logo" src="images/icons/cl-logo.svg" className="h-50px app-sidebar-logo-default" /> */}
                    <img alt="Logo" src={process.env.PUBLIC_URL + '/images/icons/cl-logo.svg'} className="h-50px app-sidebar-logo-default" />

                    {/* <img alt="Logo" src="/media/logos/default-dark.svg" className="h-25px app-sidebar-logo-default" /> */}
                    {/* <img alt="Logo" src="/media/logos/default-small.svg" className="h-20px app-sidebar-logo-minimize" /> */}
                </Link>

                {/* TOGGLE */}
                {/* <div id="kt_app_sidebar_toggle" className="app-sidebar-toggle btn btn-icon btn-shadow btn-sm btn-color-muted btn-active-color-primary body-bg h-30px w-30px position-absolute top-50 start-100 translate-middle rotate" data-kt-toggle="true" data-kt-toggle-state="active" data-kt-toggle-target="body" data-kt-toggle-name="app-sidebar-minimize">
                    <span className="svg-icon svg-icon-2 rotate-180">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path opacity="0.5" d="M14.2657 11.4343L18.45 7.25C18.8642 6.83579 18.8642 6.16421 18.45 5.75C18.0358 5.33579 17.3642 5.33579 16.95 5.75L11.4071 11.2929C11.0166 11.6834 11.0166 12.3166 11.4071 12.7071L16.95 18.25C17.3642 18.6642 18.0358 18.6642 18.45 18.25C18.8642 17.8358 18.8642 17.1642 18.45 16.75L14.2657 12.5657C13.9533 12.2533 13.9533 11.7467 14.2657 11.4343Z" fill="currentColor"></path>
                            <path d="M8.2657 11.4343L12.45 7.25C12.8642 6.83579 12.8642 6.16421 12.45 5.75C12.0358 5.33579 11.3642 5.33579 10.95 5.75L5.40712 11.2929C5.01659 11.6834 5.01659 12.3166 5.40712 12.7071L10.95 18.25C11.3642 18.6642 12.0358 18.6642 12.45 18.25C12.8642 17.8358 12.8642 17.1642 12.45 16.75L8.2657 12.5657C7.95328 12.2533 7.95328 11.7467 8.2657 11.4343Z" fill="currentColor"></path>
                        </svg>
                    </span>
                </div> */}
            </div>
        )
    }
}
